import { j as e } from "../../jsx-runtime-B6kdoens.js";
import { useMemo as g, useContext as j } from "react";
import { c as x } from "../../index-CROKJrb5.js";
import { c as h, f as w } from "../../create-component-CBAeEoQ6.js";
import { F as y } from "../../FormControlContext-C7A4R-3o.js";
import { MinusIcon as N } from "../Icon/icons/MinusIcon/index.js";
import { CircleIcon as z } from "../Icon/icons/CircleIcon/index.js";
import { CheckmarkIcon as I } from "../Icon/icons/CheckmarkIcon/index.js";
import { useBrand as M } from "../../brand/context/index.js";
import { Typography as v } from "../Typography/index.js";
import { u as B } from "../../use-unique-id-BA9hSqap.js";
const L = (t, r) => r ? "disabled" : t === "" ? "default" : t, S = x({
  base: "cur-relative cur-group cur-flex-none focus-within:cur-ring-offset-white focus-within:cur-ring-2",
  variants: {
    size: {
      sm: "cur-h-4 cur-w-4 focus-within:cur-ring-offset-2",
      md: "cur-h-6 cur-w-6 focus-within:cur-ring-offset-[3px]"
    },
    state: {
      default: "focus-within:cur-border-focus focus-within:cur-ring-focus",
      critical: "focus-within:cur-ring-border-error",
      warning: "focus-within:cur-ring-border-warning",
      success: "focus-within:cur-ring-border-success",
      disabled: null
    },
    type: {
      checkbox: null,
      radio: "cur-rounded-full"
    }
  }
}), A = x({
  base: "cur-absolute cur-inset-0 -cur-z-20",
  variants: {
    size: {
      sm: "cur-border-2",
      md: "cur-border-3"
    },
    type: {
      checkbox: null,
      radio: "cur-rounded-full"
    },
    state: {
      default: "cur-border-border-secondary",
      critical: "cur-border-border-error",
      warning: "cur-border-border-warning",
      success: "cur-border-border-success",
      disabled: "cur-border-disabled"
    }
  }
}), F = x({
  base: "cur-absolute cur-inset-1/2 -cur-translate-x-1/2 -cur-translate-y-1/2 cur-scale-0 cur-opacity-0 cur-transition-all peer-checked:cur-opacity-100",
  variants: {
    brand: {
      curology: null,
      agency: null
    },
    state: {
      default: null,
      critical: "cur-text-border-error",
      warning: "cur-text-border-warning",
      success: "cur-text-border-success",
      disabled: "cur-text-disabled"
    },
    size: {
      sm: null,
      md: null
    },
    type: {
      checkbox: null,
      radio: "peer-checked:cur-scale-50"
      // Radios scale in half
    },
    indeterminate: {
      true: null,
      false: null
    }
  },
  compoundVariants: [
    {
      state: "default",
      indeterminate: !1,
      className: "cur-text-surface-brand-accent"
    },
    {
      state: "default",
      indeterminate: !0,
      className: "cur-text-disabled"
    },
    {
      size: "sm",
      type: "checkbox",
      className: "peer-checked:cur-scale-50"
      // Small checkboxes scale in half
    },
    {
      size: "md",
      type: "checkbox",
      className: "peer-checked:cur-scale-[.58333]"
      // Shrink to 14px from 24px for a medium checkbox
    },
    // AGENCY
    {
      brand: "agency",
      state: "default",
      className: "cur-text-border-secondary"
    }
  ]
}), W = x({
  base: "cur-absolute cur-inset-1/2 -cur-z-30 cur-block cur-opacity-0 -cur-translate-x-1/2 -cur-translate-y-1/2 cur-rounded-full cur-bg-surface-highlight cur-transition-all",
  variants: {
    size: {
      sm: "cur-h-[1.75rem] cur-w-[1.75rem]",
      md: ""
    },
    disabled: {
      false: "group-hover:cur-opacity-100"
    },
    type: {
      checkbox: null,
      radio: null
    }
  },
  compoundVariants: [
    {
      size: "md",
      type: "checkbox",
      className: "cur-h-[2.5rem] cur-w-[2.5rem]"
    },
    {
      size: "md",
      type: "radio",
      className: "cur-h-[2.375rem] cur-w-[2.375rem]"
    }
  ]
}), R = h(
  "CheckboxCheck",
  w(
    ({
      as: t,
      disabled: r = !1,
      indeterminate: o = !1,
      onClick: n,
      id: l,
      size: a = "md",
      type: s = "checkbox",
      state: d = "",
      ...i
    }, f) => {
      const p = M(), c = t || "input", m = L(d, r), b = g(() => o ? N : s === "radio" ? z : I, [o, s]), k = S({
        size: a,
        state: m,
        type: s
      }), u = F({
        brand: p,
        indeterminate: o,
        size: a,
        state: m,
        type: s
      }), C = A({
        size: a,
        state: m,
        type: s
      });
      return /* @__PURE__ */ e.jsx("div", { className: "cur-relative cur-z-0", children: /* @__PURE__ */ e.jsxs("div", { className: k, children: [
        /* @__PURE__ */ e.jsxs("div", { className: "cur-absolute cur-inset-0 cur-overflow-hidden", children: [
          /* @__PURE__ */ e.jsx(
            c,
            {
              onClick: n,
              className: "cur-peer cur-absolute cur-left-0 cur-top-0 cur-z-10 cur-h-full cur-w-full cur-opacity-0",
              disabled: r,
              type: s,
              id: l,
              state: d,
              ...i,
              ref: f
            }
          ),
          /* @__PURE__ */ e.jsx(b, { className: u, size: a, "aria-hidden": !0 }),
          /* @__PURE__ */ e.jsx("div", { className: C, "aria-hidden": !0 })
        ] }),
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: W({ disabled: r, size: a, type: s }),
            "aria-hidden": !0
          }
        )
      ] }) });
    }
  )
), V = h("CheckboxMainLabel", ({ children: t, ...r }) => /* @__PURE__ */ e.jsx(v, { ...r, children: t })), q = h(
  "CheckboxMeta",
  ({ children: t, ...r }) => /* @__PURE__ */ e.jsx(
    v,
    {
      className: "cur-ml-2",
      size: "meta",
      ...r,
      children: t
    }
  )
), E = x({
  base: "cur-flex cur-flex-col",
  variants: {
    size: {
      sm: "-cur-mt-1",
      md: null
    }
  }
}), T = h(
  "CheckboxLabel",
  ({ label: t, meta: r, id: o, size: n = "md" }) => /* @__PURE__ */ e.jsxs("label", { className: E({ size: n }), htmlFor: o, children: [
    /* @__PURE__ */ e.jsx(V, { children: t }),
    r ? /* @__PURE__ */ e.jsx(q, { className: "cur-mt-1 cur-text-subtle", children: r }) : null
  ] })
), U = x({
  base: "cur-mt-2",
  variants: {
    size: {
      sm: "cur-pl-6",
      md: "cur-pl-8"
    }
  }
}), D = h(
  "CheckboxBase",
  w(
    ({
      alwaysShowChildren: t,
      checked: r,
      children: o,
      className: n,
      id: l,
      label: a,
      onChange: s,
      meta: d,
      size: i = "md",
      state: f = "",
      type: p = "checkbox",
      value: c,
      ...m
    }, b) => {
      const k = s ? (u) => s == null ? void 0 : s(u, u.target.value) : void 0;
      return /* @__PURE__ */ e.jsxs("div", { className: n, role: "option", "aria-selected": r, children: [
        /* @__PURE__ */ e.jsxs("div", { className: "cur-flex cur-items-start cur-gap-2", children: [
          /* @__PURE__ */ e.jsx(
            R,
            {
              checked: r,
              id: l,
              onChange: k,
              ref: b,
              size: i,
              state: f,
              type: p,
              value: c,
              ...m
            }
          ),
          a ? /* @__PURE__ */ e.jsx(T, { id: l, label: a, meta: d, size: i }) : null
        ] }),
        o && (t || r) ? /* @__PURE__ */ e.jsx("div", { className: U({ size: i }), children: o }) : null
      ] });
    }
  )
), $ = h(
  "Checkbox",
  w(
    ({
      checked: t,
      disabled: r,
      id: o,
      name: n,
      onChange: l,
      size: a,
      state: s,
      type: d,
      value: i,
      ...f
    }, p) => {
      const c = j(y), m = B("checkbox", o);
      r = r || c.disabled, n = n || c.name, a = a || c.size, s = s || c.state, d = d || c.type;
      const b = g(
        () => l || c.onChange ? (u) => {
          var C;
          l == null || l(u, u.target.value), (C = c.onChange) == null || C.call(c, u, u.target.value);
        } : void 0,
        [l, c]
      ), k = g(() => {
        var u;
        return t || (b ? Array.isArray(c.value) && ((u = c.value) == null ? void 0 : u.includes(i)) : void 0);
      }, [t, b, i, c.value]);
      return /* @__PURE__ */ e.jsx(
        D,
        {
          id: m,
          disabled: r,
          name: n,
          size: a,
          state: s,
          type: d,
          onChange: b,
          checked: k,
          value: i,
          ...f,
          ref: p
        }
      );
    }
  )
);
export {
  $ as Checkbox,
  D as CheckboxBase
};
//# sourceMappingURL=index.js.map
